import { faArrowsRotate } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Tooltip } from 'antd'

import Button from '../../Button.jsx'

interface FilterItem {
  key: string
  value: string | number | (string | number)[]
  index?: number | string
}

interface RefreshButtonProps {
  activeFilters: FilterItem[] | Record<string, any>
  onRefreshFilterOptions?: () => void | Promise<void>
  onRefreshData?: (activeFilters: FilterItem[] | Record<string, any>) => void | Promise<void>
}

const RefreshButton = ({ activeFilters, onRefreshFilterOptions, onRefreshData }: RefreshButtonProps) => {
  const handleRefreshClick = async () => {
    const promises: (void | Promise<void>)[] = []

    if (onRefreshFilterOptions) {
      promises.push(onRefreshFilterOptions())
    }

    if (onRefreshData) {
      promises.push(onRefreshData(activeFilters))
    }

    await Promise.all(promises)
  }

  return (
    <Tooltip title='Refresh' placement='bottom'>
      <Button
        type='primary'
        size='middle'
        icon={<FontAwesomeIcon icon={faArrowsRotate} className='text-sm' />}
        onClick={handleRefreshClick}
        className='text-white min-w-9 h-8 flex items-center justify-center hover:scale-105 transition-transform'
      />
    </Tooltip>
  )
}

export default RefreshButton
